import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import HorariosConsulta from '../pages/HorariosConsulta';
//import FooterPage from './FooterPage';
//import NavBar from './NavBar';
import '../css/NavBar.css';

/**
 * AppRouter
 * 
 * Rutas disponibles:
 *   /                  → HomePage (bienvenida)
 *   /horarios          → Módulo unificado Horarios de Consulta (tabla + tarjetas)
 * 
 * Las rutas anteriores /consultaAlu y /consultaCtrl
 * fueron reemplazadas por /horarios que integra ambas vistas.
 */
function AppRouter() {
  return (
    <div>
      <BrowserRouter>
        {/* <NavBar /> */}
        <Routes>
          <Route exact path="/"         element={<HomePage />}          />
          <Route exact path="/horarios" element={<HorariosConsulta />}  />

          {/* Alias de compatibilidad hacia atrás */}
          <Route exact path="/consultaAlu"  element={<HorariosConsulta />} />
          <Route exact path="/consultaCtrl" element={<HorariosConsulta />} />
        </Routes>
        {/* <FooterPage /> */}
      </BrowserRouter>
    </div>
  );
}

export default AppRouter;
